import React from "react";
import excel from "../../images/excel.png";
import CheckPaymentList from "./CheckPaymentList.js";
import PaymentReportPagination, { PaymentReportHeaderRow } from "./PaymentReportPagination";
import usePaymentReport from "./usePaymentReport";
import usePaymentPagination from "./usePaymentPagination";
import { buildPaymentRows, downloadPaymentXlsx } from "./paymentExcel";

export default function CheckPaymentStatus(props) {
    const data = usePaymentReport("check", props);
    const { offset, limit, page, itemsPerPage, setitems, pageBack, pageForward } = usePaymentPagination(data);

    function handleDownloadClick() {
        const rows = buildPaymentRows(data, {
            idLabel: "Check Number",
            getIdCell: (patient) => {
                try {
                    return patient.claim_data.check_num;
                } catch {
                    return "";
                }
            },
        });
        downloadPaymentXlsx(rows, "Check Payment Status", "CheckPaymentStatus");
    }

    return (
        <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="clear">
                <div className="border-color">
                    <strong>
                        <span className="underline">Check Payment Status:</span>
                    </strong>
                    <strong>Approved:</strong> Claim has been approved and awaiting check to be issued <br />
                    <strong>Paid:</strong> Claim is approved and check has been mailed to the address on file <br />
                    <strong>Check Cleared:</strong> Funds have been deposited into the account
                </div>
            </div>
            <span className="tooltip" style={{ float: "right" }}>
                <a onClick={handleDownloadClick}>
                    <img src={excel} className="excel" />
                </a>
                <span className="tooltiptext">
                    Click here to download entire patient list. Please note there is a 24 hour delay for newly enrolled patients to be
                    included in this excel list
                </span>
            </span>
            <table style={{ marginTop: "0", marginBottom: "0" }} className="account">
                <tbody>
                    <PaymentReportHeaderRow idLabel="Check Number" />
                    <CheckPaymentList data={data} page={page} items={itemsPerPage} offset={offset} limit={limit} />
                </tbody>
            </table>
            <PaymentReportPagination
                data={data}
                offset={offset}
                limit={limit}
                setitems={setitems}
                pageBack={pageBack}
                pageForward={pageForward}
            />
        </div>
    );
}


